import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import KnowledgeBaseDataRepository from '../../../../data/repositories/KnowledgeBaseRepository';
import KnowledgeBaseRepository from '../../../repositories/KnowledgeBaseRepository';

export default function* saga(): any {
  try {
    yield put({ type: Types.GET_METADATA_REQUEST });
    const knowledgeBaseRepository: KnowledgeBaseRepository =
      new KnowledgeBaseDataRepository();
    const { data } = yield select((state) => state.profile);
    const metadataResponse = yield call(
      knowledgeBaseRepository.getMetadata,
      !!data
    );
    if (!metadataResponse) {
      yield put({
        type: Types.GET_CATEGORIES_FAILURE,
        error: true
      });
      return;
    }
    yield put({
      type: Types.GET_METADATA_SUCCESS,
      data: metadataResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_METADATA_FAILURE,
      error: true
    });
  }
}
